export default "__VITE_ASSET__eeef5d49__"